import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

const setReadFn = (data) => apiClient.post(`${APP_API_URL}action-list/set-read`, data);

export const useSetReadMutation = () => {
  return useMutation({
    mutationFn: setReadFn,
  });
};
